export const VERSION = 'v2.0.0';
export const MAX_LAST_COMMUNICATION_DIFF_MS = 2 * 60 * 1000;